import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import TopBar from './TopBar';
interface LayoutProps {
  children: React.ReactNode;
}
const Layout: React.FC<LayoutProps> = ({
  children
}) => {
  return <div className="flex flex-col min-h-screen bg-gray-50" data-id="element-208" data-mp="zwcs0fg5gh14">
      <TopBar data-id="element-209" data-mp="uyb9pwqjslqp" />
      <Navbar data-id="element-210" data-mp="uxrski8q21dq" />
      <main className="flex-grow" data-id="element-211" data-mp="uy1fty2dtufq">{children}</main>
      <Footer data-id="element-212" data-mp="uwgo0g7gcplk" />
    </div>;
};
export default Layout;